<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputPreview'
export default {
  name: 'DAccessPathPreview',
  extends: compoment
}
</script>
